// ** Logo
import SpinnerFlex from "@src/views/components/spinners/SpinnerFlex";

const SpinnerComponent = () => {
  return (
    <div className="fallback-spinner vh-100" id="loading">
      <SpinnerFlex />
    </div>
  );
};

export default SpinnerComponent;
